import { render, staticRenderFns } from "./AllOffers.vue?vue&type=template&id=e540acdc&scoped=true&"
import script from "./AllOffers.vue?vue&type=script&lang=js&"
export * from "./AllOffers.vue?vue&type=script&lang=js&"
import style0 from "./AllOffers.vue?vue&type=style&index=0&id=e540acdc&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e540acdc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VRow})
